/*
 * ******************************************************************
 * Copyright (c) 2017-2025 Broadcom. All Rights Reserved.
 * Broadcom Confidential. The term "Broadcom" refers to Broadcom Inc.
 * and/or its subsidiaries.
 * ******************************************************************
 */
import { ChangeDetectorRef, Component, ElementRef, HostListener, Input } from "@angular/core";

// @formatter:off
@Component({
    standalone: false,
   selector: 'clipboard-icon',
   templateUrl: 'dr-clipboard-icon.component.html',
   styleUrls: ['dr-clipboard-icon.component.scss']
})
// @formatter:on
export class DrClipboardIconComponent {

    @Input()
    content: string = "";

    public copied: boolean = false;

    constructor(
        public element: ElementRef,
        private cdr: ChangeDetectorRef) {
    }

    @HostListener("click", ["$event.stopPropagation()"])
    @HostListener("keyup.space", ["$event"])
    @HostListener("keyup.enter", ["$event"])
    public click(): void {
        /**
         * document "copy" command requires us to select some text in order to be executed,
         * that is why we create a hidden input which has a select() function rather than other HTMLElements
         */
        const aux = document.createElement("input");
        aux.className += "copyToClipBoardInput";
        aux.value = this.content;
        this.element.nativeElement.appendChild(aux);
        aux.select();
        document.execCommand("copy");
        this.element.nativeElement.removeChild(aux);

        this.copied = true;
        this.cdr.detectChanges();
    }

    @HostListener("mouseleave")
    public hide(): void {
        this.copied = false;
    }
}
